import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
// import { setupListeners } from "@reduxjs/toolkit/query";
import counterReducer from "../features/counter/counterSlice";
import businessesReducer from "../features/businesses/businessesSlice";
import accountReducer from "../features/access-control/accountSlice";
import errorsReducer from "../features/errors/errorsSlice";
import catalogsReducer from "../features/catalogs/catalogsSlice";
import promotionsReducer from "../features/promotions/promotionsSlice";
import transactionTagsReducer from "../features/transaction-tags/transactionTagsSlice";
import transactionsReducer from "../features/transactions/transactionsSlice";
import bucketDealsReducer from "../features/bucket-deals/bucketDealsSlice";
import notificationsSlice from "../features/notifications/notificationsSlice";
import salesReducer from "../features/sales/SalesSlice";
import terminalsReducer from "../features/terminals/TerminalsSlice";
import partnersReducer from "../features/partners/partnersSlice";
import partnerDealsReducer from "../features/partner-deals/partnerDealsSlice";
import chatBotReducer from "../features/chat-bot/chatBotSlice";
import authReducer from "../features/access-control/authSlice";
import themeReducer from "../features/theme/themeSlice";
import adminsReducer from "../features/admins/adminsSlice";
import apkReducer from "../features/development/apkSlice";
import pppLinksReducer from "../features/ppp-links/pppLinksSlice";
import posSimulatorReducer from "../features/pos-simulator/PosSimulatorSlice";
import pricingToolReducer, {
  persistPricingToolState,
} from "../features/pricing-tool/pricingToolSlice";
import releaseNotesReducer from "../features/release-notes/releaseNotesSlice";
import paymentHealthReducer from "../features/payment-health/paymentHealthSlice";
import emailTemplatesReducer from "../features/email-templates/emailTemplatesSlice";
import featureFlagsReducer from "../features/feature-flags/featureFlagsSlice";
import bannersReducer from "../features/banners/bannersSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    account: accountReducer,
    businesses: businessesReducer,
    errors: errorsReducer,
    catalogs: catalogsReducer,
    promotions: promotionsReducer,
    transactionTags: transactionTagsReducer,
    transactions: transactionsReducer,
    bucketDeals: bucketDealsReducer,
    sales: salesReducer,
    notifications: notificationsSlice,
    terminals: terminalsReducer,
    partners: partnersReducer,
    partnerDeals: partnerDealsReducer,
    chatBot: chatBotReducer,
    auth: authReducer,
    theme: themeReducer,
    admins: adminsReducer,
    apk: apkReducer,
    pppLinks: pppLinksReducer,
    posSimulator: posSimulatorReducer,
    pricingTool: pricingToolReducer,
    releaseNotes: releaseNotesReducer,
    paymentHealth: paymentHealthReducer,
    emailTemplates: emailTemplatesReducer,
    featureFlags: featureFlagsReducer,
    banners: bannersReducer,
  },
});

// Persist the pricing-tool filters so they survive a page refresh.
let lastPricingTool = store.getState().pricingTool;
store.subscribe(() => {
  const next = store.getState().pricingTool;
  if (next !== lastPricingTool) {
    lastPricingTool = next;
    persistPricingToolState(next);
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
// setupListeners(store.dispatch);
